/**
 * Unauthorized Route
 *
 * Access denied route for users without required permissions.
 *
 * @updated DOC-0099 (2025-12-26) - Use UnauthorizedPage from FSD pages layer
 */

import { createFileRoute } from '@tanstack/react-router';
import { UnauthorizedPage } from '@pages/unauthorized';

export const Route = createFileRoute('/$locale/unauthorized')({
  component: UnauthorizedRoute,
});

function UnauthorizedRoute() {
  return <UnauthorizedPage />;
}
